import { useQuery } from 'react-query';
import { checkoutService } from 'services';
import { ServerStateKeysEnum } from '../constants';
import { Modes } from 'components/OrderCheckout';

export const useShipments = (mode: Modes) => {
  return useQuery(
    `${ServerStateKeysEnum.orderShipments}`,
    () => {
      return checkoutService.getShippingRates();
    },
    {
      enabled: mode !== 'start',
      refetchOnWindowFocus: false,
    }
  );
};
